import LegalLayout from '../components/LegalLayout';

const SECTIONS = [
  { type: 'p', text: 'Support and legal guidance for ShiftCover365 users.' },

  { type: 'h1', text: '1. Help Overview' },
  { type: 'p', text: 'This page helps users find support, platform guidance and legal information for ShiftCover365.' },

  { type: 'h1', text: '2. Account Support' },
  { type: 'p', text: 'For login, email verification, password reset or account access issues, contact support@shiftcover365.co.uk. Include your name, email address and whether you are using a manager or worker account.' },

  { type: 'h1', text: '3. Worker Onboarding Support' },
  { type: 'p', text: 'Workers should ensure profile details, experience level, role type and contact information are accurate before applying for shifts. Workers should only apply for shifts they are able and qualified to complete.' },

  { type: 'h1', text: '4. Manager Onboarding Support' },
  { type: 'p', text: 'Managers should ensure branch details, shift requirements, contact information and operational instructions are accurate before posting shifts or approving workers.' },

  { type: 'h1', text: '5. Verification Support' },
  { type: 'p', text: 'Smart ID status inside ShiftCover365 is either self-declared by the worker or confirmed by a manager. ShiftCover365 does not perform formal identity-document checks, background checks, criminal-record checks or right-to-work verification. Managers remain responsible for final suitability and right-to-work checks.' },

  { type: 'h1', text: '6. Shift Accountability Guidance' },
  { type: 'p', text: 'Shift records, check-ins, ratings, till start/mid/end checks, periodic till checks and discrepancy reports support transparency and operational visibility. They should be used fairly and reviewed in context, not treated as automatic proof of misconduct.' },

  { type: 'h1', text: '7. Legal Documents' },
  { type: 'p', text: 'Users should review the Privacy Policy, Terms & Conditions and Cookie Policy before using the platform. These documents are updated as the platform evolves.' },

  { type: 'h1', text: '8. Data Protection Requests' },
  { type: 'p', text: 'For data access, correction, deletion, restriction, objection or portability requests, contact support@shiftcover365.co.uk. Requests are handled in line with applicable UK data protection law, generally within one month. Self-service in-app tools exist for profile correction and account deletion; other rights are handled manually by our support team.' },

  { type: 'h1', text: '9. Operational Status' },
  { type: 'p', text: 'ShiftCover365 is in active commercial use. Features, processors and legal wording may be updated as the platform develops. Significant changes will be reflected in the effective dates on each legal page. ShiftCover365 does not currently hold formal compliance certifications such as ISO 27001 or SOC 2; this page will be updated if that changes.' },

  { type: 'h1', text: '10. Contact' },
  { type: 'p', text: 'General enquiries: hello@shiftcover365.co.uk · Support and account issues: support@shiftcover365.co.uk.' },
];

export default function HelpLegalPage() {
  return (
    <LegalLayout
      title="Help & Legal"
      subtitle="Support and legal guidance for ShiftCover365 users."
      effectiveDate="16 February 2026"
      sections={SECTIONS}
    />
  );
}
